// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"bV-z","inlineTitle":"cV-z","sponsoredAdsWrapper":"dV-z","marketplaceRecosWrapper":"eV-z"};